import { Actions, ComponentNames, Entities, EventNames, ScreenNames } from 'src/utils/datahub/enums'
import { useOptimizely } from 'src/hook/useOptimizely'

function useTrackEvents() {
  const { optimizely } = useOptimizely()
  const enableNewFeed = Boolean(document.querySelector('[data-test="post-card"]'))

  const sendCreatePostEvent = ({ communityId, communityName }) => {
    optimizely.push({
      type: 'event',
      eventName: EventNames.CLICK_TO_CREATE_POST,
      tags: {
        action: Actions.VIEW,
        entity: Entities.COMMUNITY,
        screenName: ScreenNames.COMMUNITY_VIEW,
        componentName: ComponentNames.INPUT_POST,
        communityId,
        communityName,
        arrivedFrom: enableNewFeed
          ? ScreenNames.COMMUNITY_NEW_FEED
          : ScreenNames.COMMUNITY_POST_LIST
      }
    })

    optimizely.track(EventNames.CLICK_TO_CREATE_POST)
  }

  return {
    sendCreatePostEvent
  }
}

export default useTrackEvents
